import { IconButton } from "@mui/material"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import Iconify from "minimals-template/components/Iconify"

export function DeleteTaskButton({ onClick, ...props }) {
    const {
        task: { temporaryTaskId, id },
    } = useBoundContext()
    const isDraft = Boolean(temporaryTaskId)

    return (
        <IconButton
            aria-label="Delete task"
            data-cy="delete-task-button"
            onClick={handleDelete}
            color="error"
            {...props}
        >
            <Iconify icon={"gravity-ui:trash-bin"} />
        </IconButton>
    )

    function handleDelete() {
        const targetId = isDraft ? temporaryTaskId : id
        onClick(targetId)
    }
}
